import Request from ".";
import { Routes } from "../constant/api_url";

const UpdateInvoiceSetting = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEINVOICESETTING, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdatePrimeDescriptionSetting = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPRIMEDESCRIPTIONSETTING, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getInvoiceSetting = async () => {
  try {
    const result = await Request.get(Routes.GETINVOICESETTING);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getSetting = async () => {
  try {
    const result = await Request.get(Routes.GETESETTING);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getContentHistory = async (type) => {
  try {
    const result = await Request.get(Routes.GETCONTENTHISTORY, { params: { type } });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const UpdateSetting = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATESETTING, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const ResetPrimeInvoiceNumber = async (data) => {
  try {
    const result = await Request.post(Routes.RESETPRIMEINVOICENUMBER, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

export {
  UpdateSetting,
  UpdateInvoiceSetting,
  UpdatePrimeDescriptionSetting,
  getSetting,
  getContentHistory,
  getInvoiceSetting,
  ResetPrimeInvoiceNumber
};
